export default __webpack_public_path__ + "media/plaid-logo-horizontal-RGB.51772.png";